import { render, staticRenderFns } from "./Semaforo.vue?vue&type=template&id=31c6c830&scoped=true&"
import script from "./Semaforo.vue?vue&type=script&lang=js&"
export * from "./Semaforo.vue?vue&type=script&lang=js&"
import style0 from "./Semaforo.vue?vue&type=style&index=0&id=31c6c830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6c830",
  null
  
)

export default component.exports